<template>
  <div class="formPage">
    <el-card>
      <p class="title">报名信息</p>
      <span style="color:red">注意：（带*的必须填写）</span>
      <div class="formItems">
        <el-form :model="applyForm" label-position="right" status-icon :rules="applyFromRules" ref="applyFormRefs"
          label-width="150px" class="demo-ruleForm">
          <el-row>
            <el-col :span="8">
              <!-- 姓名 -->
              <el-form-item label="姓名:">
                <el-input v-model="userInfo.user_name" disabled></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <!-- 身份证号 -->
              <el-form-item label="身份证号:">
                <el-input v-model="userInfo.id_card" disabled></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <!-- 出生日期 -->
              <el-form-item label="出生日期:">
                <el-input v-model="userInfo.birth" disabled></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="8">
              <!-- 报考职位 -->
              <el-form-item label="报考职位:" prop="enterJob">
                <el-select v-model="applyForm.enterJob" value-key="rec_id" @change="$forceUpdate()">
                  <el-option v-for="item in enterJobItems" :key="item.rec_id" :label="item.job_name" :value="item">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <!-- 宗教信仰 -->
              <el-form-item label="宗教信仰:" prop="religion">
                <el-select v-model="applyForm.religion">
                  <el-option v-for="(item, index) in religionItems" :key="index" :label="item" :value="item">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <!-- 贵州精准扶贫学生 -->
              <el-form-item label="贵州精准扶贫学生:" prop="PovertyStudent">
                <el-select v-model="applyForm.PovertyStudent">
                  <el-option v-for="(item, index) in PovertyStudentItems" :key="index" :label="item" :value="item">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="8">
              <el-form-item label="民族:" prop="nation">
                <el-select v-model="applyForm.nation" placeholder="选择民族">
                  <el-option v-for="(item, index) in nationItmes" :key="index" :label="item.label"
                    :value="item.value"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="籍贯:" prop="jiguan">
                <el-input v-model="applyForm.jiguan" placeholder="请输入籍贯" autocomplete="off"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="出生地:" prop="chushengdi">
                <el-input v-model="applyForm.chushengdi" placeholder="请输入出生地" autocomplete="off"></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="8"><el-form-item label="政治面貌:" prop="qunzhong">
                <el-select v-model="applyForm.qunzhong" placeholder="请选择政治面貌">
                  <el-option v-for="(item, index) in qunItmes" :key="index" :label="item.label"
                    :value="item.value"></el-option>
                </el-select> </el-form-item></el-col>
            <el-col :span="8">
              <el-form-item label="婚姻状况:" prop="hunYin">
                <el-select v-model="applyForm.hunYin" placeholder="请选择婚姻状">
                  <el-option v-for="(item, index) in hunYinItmes" :key="index" :label="item.label"
                    :value="item.value"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="身高:" prop="shengGao">
                <el-input v-model="applyForm.shengGao" :maxlength="3" placeholder="请输入身高(厘米)" type="number"></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="8">
              <el-form-item label="所学专业:" prop="zhuanYe">
                <el-input v-model="applyForm.zhuanYe" placeholder="请输入所学专业"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="最高学历:" prop="xueLi">
                <el-select v-model="applyForm.xueLi" placeholder="请选择最高学历">
                  <el-option v-for="(item, index) in xueLiItmes" :key="index" :label="item.label"
                    :value="item.value"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="现工作单位:" prop="xianDanWei">
                <el-input v-model="applyForm.xianDanWei" placeholder="请输入现工作单位或无" autocomplete="off"></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="8">
              <el-form-item label="联系地址:" prop="address">
                <el-input v-model="applyForm.address" placeholder="请输入联系地址" autocomplete="off"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <!-- 毕业时间 -->
              <el-form-item label="最高学历毕业时间:" prop="biYeDate">
                <el-date-picker placeholder="请选择毕业时间" v-model="applyForm.biYeDate" value-format="yyyy-MM-dd"
                  style="width: 100%;"></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <!-- 毕业院校 -->
              <el-form-item label="最高学历毕业院校:" prop="yuanXiao">
                <el-input v-model="applyForm.yuanXiao" placeholder="请输入毕业院校" autocomplete="off"></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="8">
              <el-form-item label="计算机能力/级别:" prop="computerLevel">
                <el-input v-model="applyForm.computerLevel" placeholder="请输入计算机能力级别" autocomplete="off"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="外语能力(语种/级别):" label-width="11em" prop="languageLevel">
                <!-- <el-input v-model="applyForm.languageLevel" placeholder="请输入所学语种及等级" autocomplete="off"></el-input> -->
                <el-select v-model="applyForm.languageLevel" placeholder="请选择外语能力">
                  <el-option v-for="(item, index) in languageLevelItems" :key="index" :label="item.label"
                    :value="item.value"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="是否具备从业资格:" prop="congye">
                <el-select v-model="applyForm.congye" placeholder="请选择是否具备从业资格">
                  <el-option label="是" value="是"></el-option>
                  <el-option label="否" value="否"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <!-- <el-col :span="8">
              <el-form-item label="是否服从调剂:" prop="tiaoJi">
                <el-select v-model="applyForm.tiaoJi" placeholder="请选择是否调剂">
                  <el-option label="是" value="是"></el-option>
                  <el-option label="否" value="否"></el-option>
                </el-select>
              </el-form-item>
            </el-col> -->
            <!-- 执业资格证书情况 -->
            <el-col :span="8">

              <el-form-item label=" 职称:" prop="JobGrade">
                <el-input v-model="applyForm.JobGrade" placeholder="请输入现有职称" autocomplete="off"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="考生来源地:" prop="teChang">
                <el-input v-model="applyForm.teChang" placeholder="考生来源地"></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="8">
              <!-- 原来为邮编 现为是否为入境来黔或省外考生 -->
              <el-form-item label="是否为入境来黔或省外考生:" prop="youbian" label-width="235px">
                <el-select v-model="applyForm.youbian" placeholder="是否为入境来黔或省外考生">
                  <el-option label="是" value="是"></el-option>
                  <el-option label="否" value="否"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <!-- 健康状况 -->
            <el-col :span="8">
              <el-form-item label="健康状况:" prop="jianKang">
                <el-input placeholder="请输入健康状况" v-model="applyForm.jianKang"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label=" 执业资格证书编号:" prop="zhengShu">
                <el-input v-model="applyForm.zhengShu" placeholder="请输入职业资格证书编号" autocomplete="off"></el-input>
              </el-form-item>

            </el-col>
          </el-row>

          <el-row>
            <el-col :span="8">
              <el-form-item label="住院医师规培专业:" prop="DoctorTrainSpecialty">
                <!-- <el-input v-model="" placeholder="请输入住院医师规培专业" ></el-input> -->
                <el-input placeholder="请输入住院医师规培专业" v-model="applyForm.DoctorTrainSpecialty"
                  autocomplete="off"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="执业证类别:" prop="DoctorGradeType">
                <el-input v-model="applyForm.DoctorGradeType" placeholder="请输入执业证类别" autocomplete="off"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="执业证范围:" prop="DoctorGradeScope">
                <el-input v-model="applyForm.DoctorGradeScope" placeholder="请输入执业证范围" autocomplete="off"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <!-- photoList: [],
	  photoTrainingList: [],
      photoDiplomaList: [],
      photoDegreeList: [],
	  photoApprovedList:[],
      photoQualificationist: [],
	  photoForeignList:[], -->
          <!-- 上传图片 -->
          <el-form-item label="近期免冠照:" prop="photo" ref="photoRef" class="photoUpload">
            <el-input v-model="applyForm.photo[0]" class="photoInput"></el-input>
            <el-upload class="upload-demo" action="string" :before-upload="beforeAvatarUpload"
              :on-preview="photoPreview" :on-remove="(file, fileList) => { photoRemove(file, fileList, 'photo', 'photoList') }"
              :on-success="uploadSuccess" :file-list="photoList" list-type="picture"
              :http-request="(file) => { uploadFile(file, 'photo') }" :limit="1" accept="image/*">
              <el-button size="small" type="primary">点击上传</el-button>
              <div slot="tip" class="el-upload__tip">
                只能上传jpg/png文件,若要替换图片请将鼠标移到右上角点击'x'删除图片再点击上传按钮
              </div>
            </el-upload>
          </el-form-item>

          <el-form-item class="photoUpload" label="毕业证:" prop="PhotoDiploma">
            <el-input v-model="photoDiplomaList[0]" class="photoInput"></el-input>
            <el-upload class="upload-demo" action="string" multiple :on-preview="photoPreview"
              :before-upload="beforeAvatarUpload"
              :on-remove="(file, fileList) => { photoRemove(file, fileList, 'PhotoDiploma', 'photoDiplomaList') }"
              :file-list="photoDiplomaList" list-type="picture"
              :http-request="(file) => { uploadFile(file, 'PhotoDiploma') }" accept="image/*">
              <el-button size="small" type="primary">点击上传</el-button>
              <div slot="tip" class="el-upload__info">
                提示：（应届毕业生，若无毕业证、学位证，请上传毕业生就业推荐表。）
              </div>
              <div slot="tip" class="el-upload__tip">
                只能上传jpg/png文件,若要替换图片请将鼠标移到右上角点击'x'删除图片再点击上传按钮
              </div>
            </el-upload>
          </el-form-item>

          <el-form-item class="photoUpload" label="学位证:" prop="PhotoDegree">
            <!-- <el-input v-model="applyForm.biYePhoto[0]" class="photoInput"></el-input> -->
            <el-upload class="upload-demo" action="string" multiple :on-preview="photoPreview"
              :before-upload="beforeAvatarUpload"
              :on-remove="(file, fileList) => { photoRemove(file, fileList, 'PhotoDegree', 'photoDegreeList') }"
              :file-list="photoDegreeList" list-type="picture" :http-request="(file) => { uploadFile(file, 'PhotoDegree') }"
              accept="image/*">
              <el-button size="small" type="primary">点击上传</el-button>
              <div slot="tip" class="el-upload__info">
                提示：（多张上传）
              </div>
              <div slot="tip" class="el-upload__tip">
                只能上传jpg/png文件,若要替换图片请将鼠标移到右上角点击'x'删除图片再点击上传按钮
              </div>
            </el-upload>
          </el-form-item>
          <el-form-item class="photoUpload" label="规培合格证/规培证明:" prop="PhotoTraining">
            <!-- <el-input v-model="applyForm.biYePhoto[0]" class="photoInput"></el-input> -->
            <el-upload class="upload-demo" action="string" multiple :on-preview="photoPreview"
              :before-upload="beforeAvatarUpload"
              :on-remove="(file, fileList) => { photoRemove(file, fileList, 'PhotoTraining', 'photoTrainingList') }"
              :file-list="photoTrainingList" list-type="picture"
              :http-request="(file) => { uploadFile(file, 'PhotoTraining') }" accept="image/*">
              <el-button size="small" type="primary">点击上传</el-button>
              <div slot="tip" class="el-upload__info">
                提示：（多张上传）
              </div>
              <div slot="tip" class="el-upload__tip">
                只能上传jpg/png文件,若要替换图片请将鼠标移到右上角点击'x'删除图片再点击上传按钮
              </div>
            </el-upload>
          </el-form-item>
          <el-form-item label="资格证/执业证:" class="photoUpload" prop="PhotoQualification">
            <el-upload class="upload-demo" action="string" multiple :on-preview="photoPreview"
              :on-remove="(file, fileList) => { photoRemove(file, fileList, 'PhotoQualification', 'photoQualificationist') }"
              :before-upload="beforeAvatarUpload" :file-list="photoQualificationist" list-type="picture"
              :http-request="(file) => { uploadFile(file, 'PhotoQualification') }" accept="image/*">
              <el-button size="small" type="primary">点击上传</el-button>
              <div slot="tip" class="el-upload__info">
                提示： （多张上传）
              </div>
              <div slot="tip" class="el-upload__tip">
                只能上传jpg/png文件,若要替换图片请将鼠标移到右上角点击'x'删除图片再点击上传按钮
              </div>
            </el-upload></el-form-item>
          <el-form-item label="同意报考证明:" class="photoUpload" prop="PhotoApproved">
            <el-upload class="upload-demo" action="string" multiple :on-preview="photoPreview"
              :on-remove="(file, fileList) => { photoRemove(file, fileList, 'PhotoApproved', 'photoApprovedList') }"
              :before-upload="beforeAvatarUpload" :file-list="photoApprovedList" list-type="picture"
              :http-request="(file) => { uploadFile(file, 'PhotoApproved') }" accept="image/*">
              <el-button size="small" type="primary">点击上传</el-button>
              <div slot="tip" class="el-upload__info">
                提示：（有工作单位的考生须提交同意报考证明）
              </div>
              <div slot="tip" class="el-upload__tip">
                只能上传jpg/png文件,若要替换图片请将鼠标移到右上角点击'x'删除图片再点击上传按钮
              </div>
            </el-upload></el-form-item>



          <el-form-item label="外语证/职称证书" class="photoUpload" prop="PhotoForeign">
            <el-upload class="upload-demo" action="string" multiple :on-preview="photoPreview"
              :on-remove="(file, fileList) => { photoRemove(file, fileList, 'PhotoForeign', 'photoForeignList') }"
              :before-upload="beforeAvatarUpload" :file-list="photoForeignList" list-type="picture"
              :http-request="(file) => { uploadFile(file, 'PhotoForeign') }" accept="image/*">
              <el-button size="small" type="primary">点击上传</el-button>
              <div slot="tip" class="el-upload__info">
                提示：(可多张合并上传)
              </div>
              <div slot="tip" class="el-upload__tip">
                只能上传jpg/png文件,若要替换图片请将鼠标移到右上角点击'x'删除图片再点击上传按钮
              </div>
            </el-upload></el-form-item>

          <!-- 工作经历 -->
          <el-row class="workDiv">
            <el-col>
              <el-form-item label="个人学习及工作经历:" prop="jingli" label-width="100"> </el-form-item>
              <div class="el-upload__info" style="margin-bottom: 10px;">
                提示：需完善高中至今简历
              </div>
            </el-col>
            <el-row class="workDivTitle">
              <el-col :span="4">
                <p>开始时间:</p>
              </el-col>
              <el-col :span="4" :offset="1">
                <p>结束时间:</p>
              </el-col>
              <el-col :span="4" :offset="1">
                <p>工作单位:</p>
              </el-col>
              <el-col :span="4" :offset="1">
                <p>工作方式:</p>
              </el-col>
            </el-row>
            <el-col>
              <el-row v-for="(item, index) in applyForm.jingli" :key="index" ref="jingliRefs" class="jingliBottom">
                <el-col :span="4">
                  <el-date-picker placeholder="开始时间" v-model="applyForm.jingli[index].beginDate"
                    :picker-options="startOptions" value-format="yyyy-MM-dd" style="width: 100%;"></el-date-picker>
                </el-col>
                <el-col :span="4" :offset="1">
                  <el-date-picker placeholder="结束时间" v-model="applyForm.jingli[index].endDate"
                    :picker-options="endOptions" value-format="yyyy-MM-dd" style="width: 100%;"></el-date-picker>
                </el-col>
                <el-col :span="4" :offset="1">
                  <el-input placeholder="请输入工作单位" v-model="applyForm.jingli[index].officeAddress"></el-input>
                </el-col>
                <el-col :span="4" :offset="1">
                  <el-select v-model="applyForm.jingli[index].workStyle" placeholder="工作方式">
                    <el-option label="实习" value="实习"></el-option>
                    <el-option label="工作" value="工作"></el-option>
                    <el-option label="学习" value="学习"></el-option>
                    <el-option label="待业" value="待业"></el-option>
                    <el-option label="规培" value="规培"></el-option>
                  </el-select>
                </el-col>
                <el-col :span="3" class="iconCol">
                  <i v-if="index > applyForm.jingli.length - 2" class="el-icon-circle-plus-outline"
                    @click="addWorkList(index)"></i>
                  <i v-if="applyForm.jingli.length > 1" class="el-icon-remove-outline"
                    @click="reduceWorkList(index)"></i>
                </el-col>
              </el-row>
            </el-col>
          </el-row>
          <!-- 家庭成员 -->
          <el-row class="workDiv">
            <el-col>
              <el-form-item label="家庭成员及基本情况:" prop="family" label-width="100"> </el-form-item>
            </el-col>
            <el-row class="workDivTitle">
              <el-col :span="3">
                <p>成员姓名:</p>
              </el-col>
              <el-col :span="3" :offset="1">
                <p>成员与本人关系:</p>
              </el-col>
              <el-col :span="3" :offset="1">
                <p>成员工作单位:</p>
              </el-col>
              <el-col :span="3" :offset="1">
                <p>成员年龄:</p>
              </el-col>
              <el-col :span="3" :offset="1">
                <p>成员职业:</p>
              </el-col>
            </el-row>
            <el-col>
              <el-row v-for="(item, index) in applyForm.family" :key="index" ref="familyRrfs" class="jingliBottom">
                <el-col :span="3">
                  <el-input placeholder="成员姓名" v-model="applyForm.family[index].name" style="width: 100%;"></el-input>
                </el-col>
                <el-col :span="3" :offset="1">
                  <el-input placeholder="成员与本人关系" v-model="applyForm.family[index].relative"
                    style="width: 100%;"></el-input>
                </el-col>
                <el-col :span="3" :offset="1">
                  <el-input placeholder="成员工作单位" v-model="applyForm.family[index].officeAddress"></el-input>
                </el-col>
                <el-col :span="3" :offset="1">
                  <el-input v-model="applyForm.family[index].age" :maxlength="3" placeholder="成员年龄"> </el-input>
                </el-col>
                <el-col :span="3" :offset="1">
                  <el-input v-model="applyForm.family[index].job" placeholder="成员职业"> </el-input>
                </el-col>
                <el-col :span="3" class="iconCol">
                  <i v-if="index > applyForm.family.length - 2" class="el-icon-circle-plus-outline"
                    @click="addFamilyList(index)"></i>
                  <i v-if="applyForm.family.length > 1" class="el-icon-remove-outline"
                    @click="reduceFamilyList(index)"></i>
                </el-col>
              </el-row>
            </el-col>
          </el-row>
          <el-form-item label="奖励惩戒情况:" class="photoUpload">
            <el-input type="textarea" v-model="applyForm.RewardsPunishments" placeholder="请输入奖励惩戒情况"></el-input>
          </el-form-item>
          <!-- <el-form-item label="专业证明及所学课程清单:" class="photoUpload">
            <el-input type="textarea" v-model="applyForm.SpecialtyRemark" placeholder="请输入专业证明及所学课程清单"></el-input>
          </el-form-item> -->
          <el-form-item label="专业证明及所学课程清单" class="photoUpload" prop="SpecialtyRemark">
            <el-upload class="upload-demo" action="string" multiple :on-preview="photoPreview"
              :on-remove="(file, fileList) => { photoRemove(file, fileList, 'SpecialtyRemark', 'specialtyRemarkList') }"
              :before-upload="beforeAvatarUpload" :file-list="specialtyRemarkList" list-type="picture"
              :http-request="(file) => { uploadFile(file, 'SpecialtyRemark') }" accept="image/*">
              <el-button size="small" type="primary">点击上传</el-button>
              <!-- <div slot="tip" class="el-upload__info">
                提示：（多张上传）
              </div> -->
              <div slot="tip" class="el-upload__tip">
                只能上传jpg/png文件,若要替换图片请将鼠标移到右上角点击'x'删除图片再点击上传按钮
              </div>
            </el-upload></el-form-item>
          <el-form-item label="其他需要说明事项:" class="photoUpload">
            <el-input type="textarea" v-model="applyForm.SignupRemark" placeholder="请输入其他需要说明事项"></el-input>
          </el-form-item>
          <!-- 提交 -->
          <el-form-item>
            <el-button type="primary" @click="submitForm">确认提交 </el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-card>
  </div>
</template>
<script>
import { mapMutations, mapState } from 'vuex'
export default {
  data() {
    // const validatePhone = (rule, value, callback) => {
    //   if (!value) {
    //     return callback(new Error('手机号不能为空'))
    //   } else {
    //     const reg = /^1[3|4|5|7|8][0-9]\d{8}$/
    //     if (reg.test(value)) {
    //       callback()
    //     } else {
    //       return callback(new Error('请输入正确的手机号'))
    //     }
    //   }
    // }
    const validatePersonal = (rule, value, callback) => {
      if (!value[0].beginDate || !value[0].endDate || !value[0].officeAddress || !value[0].workStyle) {
        return callback(new Error('请输入至少一条完整的工作经历'))
      }
      value.forEach((item, index) => {
        const num = index + 1
        if (!item.beginDate || !item.endDate || !item.officeAddress || !item.workStyle) {
          return callback(new Error('第' + num + '条数据不完整，请补充完整或删除'))
        }
        if (item.beginDate > item.endDate) {
          return callback(new Error('第' + num + '条数据有误，结束时间应大于等于开始时间'))
        }
      })
      return callback()
    }
    const validateFamily = (rule, value, callback) => {
      let reg = /^[0-9]{1,3}$/
      if (!value[0].name || !value[0].relative || !value[0].officeAddress || !value[0].age || !value[0].job) {
        return callback(new Error('请输入至少一条完整的家庭成员基本情况'))
      }
      value.forEach((item, index) => {
        const num = index + 1
        if (!item.name || !item.relative || !item.officeAddress || !item.age || !item.job) {
          return callback(new Error('第' + num + '条数据不完整，请补充完整或删除'))
        }
        if (!reg.test(item.age)) {
          return callback(new Error('年龄输入有误，请输入正整数'))
        }
      })
      return callback()
    }
    return {
      // 配置时间不能大于当前
      startOptions: {
        disabledDate: time => {
          return time.getTime() > Date.now()
        }
      },
      endOptions: {
        disabledDate: time => {
          return time.getTime() < this.value1 || time.getTime() > Date.now()
        }
      },
      workInd: 0,
      familyInd: 0,
      // 图像数据
      photoList: [],
      photoTrainingList: [],
      photoDiplomaList: [],
      photoDegreeList: [],
      photoApprovedList: [],
      photoQualificationist: [],
      photoForeignList: [],
      specialtyRemarkList: [],
      userInfo: {
        user_name: '',
        id_card: '',
        birth: ''
      },
      // 验证
      applyFromRules: {
        enterJob: [{ required: true, message: '请输入选择报考职位', trigger: 'change' }],
        religion: [
          {
            required: true,
            message: '请选择信息',
            trigger: 'change'
          }
        ],
        PovertyStudent: [
          {
            required: true,
            message: '请选择信息',
            trigger: 'change'
          }
        ],
        nation: [
          {
            required: true,
            message: '请选择信息',
            trigger: 'change'
          }
        ],
        jiguan: [
          {
            required: true,
            message: '请输入信息',
            trigger: ['change', 'blur']
          }
        ],
        chushengdi: [
          {
            required: true,
            message: '请输入信息',
            trigger: ['change', 'blur']
          }
        ],
        qunzhong: [
          {
            required: true,
            message: '请选择信息',
            trigger: 'change'
          }
        ],
        hunYin: [
          {
            required: true,
            message: '请选择信息',
            trigger: 'change'
          }
        ],
        shengGao: [
          {
            required: true,
            message: '请输入信息',
            trigger: ['change', 'blur']
          },
          {
            pattern: /^[1-9]{1}[0-9]{1,3}$/,
            message: '输入有误，身高为正整数',
            trigger: 'blur'
          }
        ],
        zhuanYe: [
          {
            required: true,
            message: '请输入信息',
            trigger: ['change', 'blur']
          }
        ],
        xueLi: [
          {
            required: true,
            message: '请选择信息',
            trigger: 'change'
          }
        ],
        xianDanWei: [
          {
            required: true,
            message: '请输入信息没有请填无',
            trigger: ['change', 'blur']
          }
        ],
        address: [
          {
            required: true,
            message: '请输入信息',
            trigger: ['change', 'blur']
          }
        ],
        biYeDate: [
          {
            required: true,
            message: '请选择日期',
            trigger: 'change'
          }
        ],
        yuanXiao: [
          {
            required: true,
            message: '请输入信息',
            trigger: ['change', 'blur']
          }
        ],
        computerLevel: [
          {
            required: true,
            message: '请输入信息没有请填无',
            trigger: ['change', 'blur']
          }
        ],
        languageLevel: [
          {
            required: true,
            message: '请输入信息没有请填无',
            trigger: ['change', 'blur']
          }
        ],
        congye: [
          {
            required: true,
            message: '请选择是否信息',
            trigger: 'change'
          }
        ],
        // tiaoJi: [
        //   {
        //     required: true,
        //     message: '请选择信息',
        //     trigger: 'change'
        //   }
        // ],
        zhengShu: [
          {
            required: true,
            message: '请输入信息没有请填无',
            trigger: ['change', 'blur']
          }
        ],
        teChang: [
          {
            required: true,
            message: '请输入信息',
            trigger: ['change', 'blur']
          }
        ],
        jianKang: [
          {
            required: true,
            message: '请输入信息',
            trigger: ['change', 'blur']
          }
        ],
        youbian: [
          {
            required: true,
            message: '请输入信息',
            trigger: ['change', 'blur']
          }
        ],
        jingli: [
          {
            required: true,
            validator: validatePersonal,
            trigger: ['blur', 'change']
          }
        ],
        family: [
          {
            required: true,
            validator: validateFamily,
            trigger: ['blur', 'change']
          }
        ],
        photo: [
          {
            required: true,
            message: '未上传近期免冠照或上传失败,请重新上传',
            trigger: ['blur', 'change']
          }
        ],
        PhotoDiploma: [
          {
            required: true,
            message: '未上传毕业证扫描件或上传失败，请重新上传',
            trigger: ['blur', 'change']
          }
        ]
      },

      // 表单数据
      applyForm: {
        loading: true,
        enterJob: {},
        userName: '',
        idCard: '',
        sex: '',
        nation: '',
        jiguan: '',
        chushengdi: '',
        qunzhong: '',
        hunYin: '',
        shengGao: '',
        zhuanYe: '',
        xueLi: '',
        xianDanWei: '',
        address: '',
        biYeDate: '',
        yuanXiao: '',
        computerLevel: '',
        languageLevel: '',
        zhengShu: '',
        congyeL: '',
        // tiaoJi: '',
        teChang: '',
        jianKang: '',
        youbian: '',
        phone: '',
        email: '',
        religion: '',
        PovertyStudent: '',
        photo: [],
        PhotoDiploma: [],
        PhotoDegree: [],
        PhotoQualification: [],
        PhotoForeign: [],
        PhotoApproved: [],
        PhotoTraining: [],
        jingli: [{ beginDate: '', endDate: '', officeAddress: '', workStyle: '' }],
        family: [{ name: '', relative: '', age: '', officeAddress: '', job: '' }],
        JobGrade: '',
        DoctorTrainSpecialty: '',
        DoctorGradeType: '',
        DoctorGradeScope: '',
        RewardsPunishments: '',
        SpecialtyRemark: [],
        SignupRemark: ''
      },
      // 选择框数据

      enterJobItems: [],
      historyData: [],
      familyData: [],
      nationItmes: [],
      qunItmes: [],
      hunYinItmes: [],
      languageLevelItems: [],
      xueLiItmes: [],
      zhuanYeItmes: [],
      religionItems: ['无', '佛教', '道教', '天主教', '基督教', '伊斯兰教'],
      PovertyStudentItems: ['是', '否']
    }
  },
  // 获取state中的编制和活动id传入
  computed: {
    ...mapState(['bianzhi', 'signup_id', 'applyJob'])
  },
  created() {
    this.getUserInfo()
    this.getJobLists()
    this.getSpecialty()
    // this.getEducation()
    this.getDict(4, 'qunItmes')
    this.getDict(1, 'xueLiItmes')
    this.getDict(3, 'nationItmes')
    this.getDict(15, 'hunYinItmes')
    this.getDict(14, 'languageLevelItems')
    if (this.applyJob) {
      this.applyForm.enterJob = this.applyJob
    }
  },
  methods: {
    ...mapMutations({
      stepAdd: 'ADD_STEP'
    }),
    //  获取用户信息
    async getUserInfo() {
      const { data: res } = await this.$axios.post('/api/user/getUserInfo')

      if (res.response_code == 200) {
        this.userInfo = res.data
        if (res.data.id_card.length == 15) {
          let birth = '19' + res.data.id_card.substr(6, 6)
          this.userInfo.birth = birth.substr(0, 4) + '-' + birth.substr(4, 2) + '-' + birth.substr(6, 2)
        } else if (res.data.id_card.length == 18) {
          let birth = res.data.id_card.substr(6, 8)
          this.userInfo.birth = birth.substr(0, 4) + '-' + birth.substr(4, 2) + '-' + birth.substr(6, 2)
        }
      }
      console.log(this.userInfo)
    },
    // 获取字典列表
    async getDict(id, type) {
      const { data: res } = await this.$axios.get('/api/common/get_dict_list', { params: { dict_class_id: id } })
      if (res.response_code == 200) {
        // console.log(res.data)
        this[type] = res.data.map((item) => {
          return { value: item, label: item }
        })
      }
    },
    // 设置图片上传前的效验
    beforeAvatarUpload(file) {
      var testmsg = file.name.substring(file.name.lastIndexOf('.') + 1)
      const extension = testmsg === 'jpg' || testmsg === 'JPG' || testmsg === 'png' || testmsg === 'PNG' || testmsg === 'JPEG' || testmsg === 'jpeg'
      const isLittle = file.size / 1024 / 1024 < 2
      if (!extension) {
        this.$message({
          message: '上传图片只能是jpg / png / jpeg格式!',
          type: 'error',
          offset: 300
        })
        return false //必须加上return false; 才能阻止
      }
      console.log(file)
      if (!isLittle) {
        this.$message({
          message: '上传文件大小不能超过 500kb!',
          type: 'error',
          offset: 300
        })
        return false
      }
      return extension || isLittle
    },
    // 获取报考职位信息
    getJobLists() {
      const params = {
        signupId: this.$route.query.singupId,
        bianzhi: this.$route.query.bianzhi
      }
      this.$axios
        .get('api/signup/jobList', {
          params: params
        })
        .then(result => {
          const { data: res } = result
          console.log(result)
          this.enterJobItems = res.data
          console.log(this.enterJobItems)
        })
    },
    // 获取专业信息
    getSpecialty() {
      const params = {
        bianzhi: this.$route.query.bianzhi
      }
      this.$axios
        .get('api/Specialty/list', {
          params: params
        })
        .then(result => {
          const { data: res } = result
          console.log(result)
          this.zhuanYeItmes = res.data
          console.log(this.zhuanYeItmes)
        })
    },

    // 获取教育信息
    /**
     * api
     */
    // 提交表单
    submitApi() {
      let loadingInstance = this.$loading({
        fullscreen: true,
        text: '正在提交...'
      })
      // const params = this.formData(
      //   {
      //     SignupType: this.applyForm.enterJob.signup_type,
      //     Regular: this.applyForm.enterJob.regular,
      //     SignupJob: this.applyForm.enterJob.job_name,
      //     Photo: JSON.stringify(this.applyForm.photo),
      //     Nation: this.applyForm.nation,
      //     Hometown: this.applyForm.jiguan,
      //     Homeplace: this.applyForm.chushengdi,
      //     Politics: this.applyForm.qunzhong,
      //     Marriage: this.applyForm.hunYin,
      //     BodyHeight: this.applyForm.shengGao,
      //     Specialty: this.applyForm.zhuanYe,
      //     Education: this.applyForm.xueLi,
      //     GraduateTime: this.applyForm.biYeDate,
      //     School: this.applyForm.yuanXiao,
      //     CoName: this.applyForm.xianDanWei,
      //     Address: this.applyForm.address,
      //     Postcode: this.applyForm.youbian,
      //     ComputerGrade: this.applyForm.computerLevel,
      //     ForeignGrade: this.applyForm.languageLevel,
      //     DoctorGrade: this.applyForm.zhengShu,
      //     IsAdjust: this.applyForm.tiaoJi,
      //     Skill: this.applyForm.teChang,
      //     BodyStatus: this.applyForm.jianKang,
      //     Qualification: this.applyForm.congye,
      //     PhotoDiploma: JSON.stringify(this.applyForm.biYePhoto),
      //     PhotoDegree: JSON.stringify(this.applyForm.PhotoDegree),
      //     PhotoQualification: JSON.stringify(this.applyForm.PhotoQualification),
      //     PhotoForeign: JSON.stringify(this.applyForm.PhotoForeign),
      //     History: JSON.stringify(this.applyForm.jingli),
      //     Family: JSON.stringify(this.applyForm.family),
      //     Religion: this.applyForm.religion,
      //     PovertyStudent: this.applyForm.PovertyStudent,
      //     JobGrade:this.applyForm.JobGrade,
      //     DoctorTrainSpecialty: this.applyForm.DoctorTrainSpecialty,
      //     DoctorGradeType:this.applyForm.DoctorGradeType,
      //     DoctorGradeScope: this.applyForm.DoctorGradeScope,
      //     RewardsPunishments:this.applyForm.RewardsPunishments
      //     // History: '测试',
      //     // Family: 'c测试'
      //   },
      //   { arrayFormat: 'repeat' }
      // )
      let params = {
        SignupType: this.applyForm.enterJob.signup_type,
        Regular: this.applyForm.enterJob.regular,
        SignupJob: this.applyForm.enterJob.job_name,
        Photo: JSON.stringify(this.applyForm.photo),
        Nation: this.applyForm.nation,
        Hometown: this.applyForm.jiguan,
        Homeplace: this.applyForm.chushengdi,
        Politics: this.applyForm.qunzhong,
        Marriage: this.applyForm.hunYin,
        BodyHeight: this.applyForm.shengGao,
        Specialty: this.applyForm.zhuanYe,
        Education: this.applyForm.xueLi,
        GraduateTime: this.applyForm.biYeDate,
        School: this.applyForm.yuanXiao,
        CoName: this.applyForm.xianDanWei,
        Address: this.applyForm.address,
        Postcode: this.applyForm.youbian,
        ComputerGrade: this.applyForm.computerLevel,
        ForeignGrade: this.applyForm.languageLevel,
        DoctorGrade: this.applyForm.zhengShu,
        // IsAdjust: this.applyForm.tiaoJi,
        Skill: this.applyForm.teChang,
        BodyStatus: this.applyForm.jianKang,
        Qualification: this.applyForm.congye,
        PhotoTraining: JSON.stringify(this.applyForm.PhotoTraining),
        PhotoDiploma: JSON.stringify(this.applyForm.PhotoDiploma),
        PhotoDegree: JSON.stringify(this.applyForm.PhotoDegree),
        PhotoApproved: JSON.stringify(this.applyForm.PhotoApproved),
        PhotoQualification: JSON.stringify(this.applyForm.PhotoQualification),
        PhotoForeign: JSON.stringify(this.applyForm.PhotoForeign),
        History: JSON.stringify(this.applyForm.jingli),
        Family: JSON.stringify(this.applyForm.family),
        Religion: this.applyForm.religion,
        PovertyStudent: this.applyForm.PovertyStudent,
        JobGrade: this.applyForm.JobGrade,
        DoctorTrainSpecialty: this.applyForm.DoctorTrainSpecialty,
        DoctorGradeType: this.applyForm.DoctorGradeType,
        DoctorGradeScope: this.applyForm.DoctorGradeScope,
        RewardsPunishments: this.applyForm.RewardsPunishments,
        SpecialtyRemark: JSON.stringify(this.applyForm.SpecialtyRemark),
        SignupRemark: this.applyForm.SignupRemark
      }
      this.$axios
        .post('/api/signup/Insert', { ...params })
        .then(result => {
          if (result.data.response_code == 200) {
            this.$router.go(0)
            loadingInstance.close()
          } else {
            this.$message({
              type: 'error',
              message: result.data.response_msg,
              offset: 300
            })
            loadingInstance.close()
          }
        })
        .catch(err => {
          loadingInstance.close()
        })
    },
    // 添加工作经历
    addWorkList(val) {
      this.applyForm.jingli.push({
        beginDate: '',
        endDate: '',
        officeAddress: '',
        workStyle: ''
      })
      this.workInd = this.workInd + 1
      console.log(val)
    },
    reduceWorkList(val) {
      this.applyForm.jingli.splice(val, 1)
      this.workInd = this.workInd - 1
    },
    // 添加家庭成员
    addFamilyList(val) {
      this.applyForm.family.push({
        name: '',
        relative: '',
        age: '',
        officeAddress: '',
        job: ''
      })
      this.familyInd = this.familyInd + 1
      console.log(val)
    },
    reduceFamilyList(val) {
      this.applyForm.family.splice(val, 1)
      this.familyInd = this.familyInd - 1
    },
    //当上传图片后，调用onchange方法，获取图片本地路径(提交重复待解决)
    /*     changePhoto(file, fileList) {
      const array = []
      // console.log(array)
      // console.log(fileList)

      fileList.forEach((el, index) => {
        const elArr = [{ url: el.url }, { name: el.name }]
        // console.log(JSON.stringify(this.photoList))
        // console.log(JSON.stringify(elArr))
        // JSON.stringify(arr).indexOf()==-1
        if (JSON.stringify(this.photoList).indexOf(JSON.stringify(elArr)) == -1) {
          array.push({
            url: el.url,
            name: el.name
          })
        }

        // this.photoList.push(list)
      })
      this.photoList = array
      // console.log(this.photoList)
      // console.log(array)
    }, */
    // 上传近期免冠照
    uploadFile(val, listName) {
      console.log(listName)
      // this.photoList.push(val)
      console.log(val)
      const fileData = new FormData()
      fileData.append('fileData', val.file)
      this.$axios
        .post('/api/UploadFile/Upload', fileData, {
          params: { fileId: 'fileData' }
        })
        .then(res => {
          this.$message({
            type: 'success',
            message: '图片上传成功',
            offset: 300
          })
          // console.log(res)
          console.log(res.data.data[0].url)
          this.applyForm[listName].push(res.data.data[0].url)
          console.log(this.applyForm[listName])

          // res.data.data.forEach(element => {
          //   let photos = {
          //     name: '近期免冠照',
          //     url: 'http://signup.tyxwl.com' + element
          //   }
          //   this.photoList.push(photos)
          // })

          console.log(this.applyForm.photo)
        })
        .catch((err) => {
          // this.photoList = []
          // this.applyForm[listName].slice()
          console.log(err)
          this.$message({
            message: err,
            type: 'error',
            offset: 300
          })

        })
    },

    photoPreview(file) {
      console.log(file)
      window.open(file.url, '_blank')
    },
    uploadSuccess(fileList, fill) {
      console.log(fileList)
      console.log(fill)
      this.$refs.photoRef.validateField('photo')
    },
    // 删除一寸照
    photoRemove(file, fileList, type, type1) {
      var index = this.applyForm[type].findIndex(item => item == file.url)
      this.applyForm[type].splice(index, 1)
      // this.applyForm.photo.splice(0, 1)
      // console.log(this.applyForm.photo)
    },

    // 表单校验并提交
    submitForm() {
      // console.log(this.$refs.applyFormRefs.validate())
      this.$refs.applyFormRefs.validate((valid, err) => {
        console.log(valid)
        if (valid) {
          // console.log('通过')
          this.$confirm('提交后进入待审核，是否确认提交?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          })
            .then(() => {
              this.submitApi()
            })
            .catch(() => {
              this.$message({
                type: 'info',
                message: '已取消提交'
              })
            })
        } else {
          console.log(err)
          this.$alert('信息填写有误，请根据出现的提示将信息补充完整！', '提示', {
            type: 'warning'
          })
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
@import '../assets/style/mixin.scss';

.formPage {
  @include autoInner;

  .el-card {
    margin-top: 25px;

    p {
      font-size: 24px;
      text-align: center;
    }

    .uploadDiv {
      margin: 40px 0 20px 15px;
    }

    .workDiv {
      border: 1px solid #ccc;
      padding: 15px;
      margin-bottom: 20px;

      .iconCol {
        display: flex;
        justify-content: space-between;
        width: 100px;
        color: #409eff;
        font-size: 34px;
        margin-left: 15px;
      }

      .workDivTitle {
        p {
          padding: 5px;
          margin: 5px 0;
          font-size: 14px;
          text-align: left;
        }
      }

      .jingliBottom {
        margin-bottom: 10px;
      }
    }

    .formItems {
      //   @include clearfix;
      border: 1px solid #ccc;
      padding: 25px;
      margin-top: 10px;

      .el-icon-remove-outline {
        color: red;
      }
    }

    .el-upload__tip {
      color: #ccc;
    }

    .el-upload__info {
      color: red;
      font-size: 12px;
      height: 17px;
    }
  }

  .photoUpload {
    .photoInput {
      display: none;
      width: 100px;
      margin-right: -1000px;

      /deep/.el-input__inner {
        height: 0px;
        border: 0px;
        // display: hidden;
      }
    }
  }

  /deep/ .el-form-item__error {
    font-size: 16px;
  }

  .photoUpload {
    border: 1px solid #ccc;
    padding: 30px;
    display: flex;
    flex-direction: column;

    /deep/ .el-form-item__label {
      width: 100% !important;
      text-align: left;
    }

    /deep/ .el-form-item__content {
      margin-left: 0 !important;
    }
  }
}
</style>
